import React from "react";
import { ContractData } from "@/pages/contracts/types";
import ContractTopFields from "@/pages/contracts/ContractDetailedView/ContractTopFields";
import ContractDetailFields from "@/pages/contracts/ContractDetailedView/ContractDetailFields";
import Ownership from "@/components/layouts/Ownership";
import { EntityType } from "@/services/hooks/entities/useEntityType";
import type { ContractFieldUpdate } from "@/pages/contracts/ContractDetailedView/ContractDetailedView";
import ContractKPIs from "@/pages/contracts/components/ContractKPIs";
import NextSteps from "@/components/layouts/NextSteps/NextSteps";

interface Props {
  contract: ContractData | undefined;
  onUpdateContractField: ContractFieldUpdate;
}

const ContractQuickViewContent: React.FC<Props> = ({
  contract,
  onUpdateContractField
}) => {
  return (
    <div className="flex flex-col w-full gap-4">
      <ContractTopFields
        className="flex-wrap gap-0 pl-5 pr-0"
        key={contract?.id}
        contract={contract}
        onUpdateField={onUpdateContractField}
      />
      <div className="flex flex-col w-full gap-4 pl-5">
        <ContractKPIs
          contract={contract}
          containerClassName="grid-cols-2"
          isQuickView
          onUpdateField={onUpdateContractField}
        />
        <ContractDetailFields
          className="w-full px-4"
          contract={contract}
          onUpdateField={onUpdateContractField}
          isQuickView
        />
        <NextSteps
          className="w-full px-4"
          entity={contract}
          entityType={EntityType.CONTRACT}
          isQuickView
        />
        <Ownership
          entity={contract}
          entityType={EntityType.CONTRACT}
          onUpdateField={onUpdateContractField}
          isQuickView
        />
      </div>
    </div>
  );
};

export default ContractQuickViewContent;
